var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrueLogoWhiteCopyright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 394.28 97.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #bcbec0;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.93,
    y1: 10.75,
    x2: 2.59,
    y2: 10.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.82,
    y1: 86.93,
    x2: 2.58,
    y2: 86.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 37.74,
    y1: 78.61,
    x2: 50.44,
    y2: 82.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 37.56,
    y1: 19.11,
    x2: 50.47,
    y2: 15.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 16.23,
    y1: 65.64,
    x2: 16.23,
    y2: 52.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 16.24,
    y1: 31.89,
    x2: 16.24,
    y2: 45.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 58.08,
    y1: 52.1,
    x2: 76.1,
    y2: 34.08,
    gradientTransform: "translate(135.13 85.25) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 58.09,
    y1: 45.58,
    x2: 46.77,
    y2: 34.26,
    gradientTransform: "translate(43.32 -25.27) rotate(44.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 379.17,
    height: 97.69,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "165.61 31.91 145.15 31.91 145.15 69.5 134.45 69.5 134.45 31.91 114.11 31.91 114.11 22.68 165.61 22.68 165.61 31.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.03,52.84c7.76-1.81,13.04-6.76,13.04-14.71,0-10.17-8.63-15.46-20.07-15.46h-32.3v46.82h10.63v-15.92h16.93l13.44,15.92h12.78l-14.45-16.65Zm-28.76-8.09v-13.11h21.13c5.62,0,9.77,1.34,9.77,6.56s-4.15,6.56-9.77,6.56h-21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m308.52,22.68v24.75c0,14.05-9.3,23.54-26.29,23.54s-26.28-9.5-26.28-23.54v-24.75h10.7v23.94c0,9.36,5.48,14.98,15.58,14.98s15.58-5.62,15.58-14.98v-23.94h10.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "379.17 60.53 379.17 69.5 330.95 69.5 330.95 22.68 378.51 22.68 378.51 31.64 341.59 31.64 341.59 41.27 372.42 41.27 372.42 50.23 341.59 50.23 341.59 60.53 379.17 60.53"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m105.81,48.84l-18.95-18.94-17.63-17.63C61.08,4.1,50.34,0,39.64,0H6.73L1.58,9.24h38.06c3.6,0,7.2.6,10.64,1.78-8.35.6-16.56,4.1-22.94,10.48l-1.17,1.17H1.59l5.14,9.23h10.2L0,48.84l16.94,16.95H6.73l-5.14,9.23h24.58l1.17,1.17c6.38,6.38,14.59,9.88,22.94,10.48-3.44,1.18-7.03,1.78-10.64,1.78H1.58l5.15,9.24h32.91c10.7,0,21.44-4.1,29.59-12.26l17.63-17.63h0s18.95-18.95,18.95-18.95Zm-13.06,0l-12.43,12.43-12.43-12.42,12.43-12.43h.01s12.41,12.43,12.41,12.43Zm-39.84-28.69c6.86.01,13.66,2.59,18.93,7.79l1.95,1.95-12.43,12.43-11.85-11.85c-3.04-3.05-6.66-5.18-10.49-6.44,4.26-2.57,9.06-3.88,13.88-3.88Zm-22.9,45.63l-16.94-16.95,16.93-16.93h.72c4.46.01,8.87,1.69,12.26,5.1l11.84,11.84-11.84,11.84c-3.39,3.4-7.81,5.08-12.26,5.1h-.71Zm22.9,11.75c-4.82,0-9.62-1.31-13.88-3.88,3.83-1.26,7.44-3.39,10.48-6.44h.01l11.84-11.84,12.42,12.42-1.95,1.95c-5.26,5.2-12.07,7.78-18.93,7.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.47,21.5l-9.24-9.24C61.08,4.1,50.34,0,39.64,0H6.73L1.58,9.24h38.06c3.6,0,7.2.6,10.64,1.78.88-.06,1.75-.1,2.63-.1,9.23-.01,18.52,3.53,25.56,10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m78.47,76.18c-7.04,7.05-16.33,10.6-25.56,10.59-.88,0-1.76-.04-2.63-.1-3.44,1.18-7.03,1.78-10.64,1.78H1.58l5.15,9.24h32.91c10.7,0,21.44-4.1,29.59-12.26l9.24-9.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m52.9,77.54c-4.82,0-9.62-1.31-13.88-3.88-2.7.89-5.51,1.36-8.31,1.36h-4.55l1.17,1.17c6.38,6.38,14.59,9.88,22.94,10.48l2.63-9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m39.02,24.03c4.26-2.57,9.06-3.88,13.88-3.88l-2.63-9.13c-8.35.6-16.56,4.1-22.94,10.48l-1.17,1.17h4.55c2.8,0,5.61.47,8.31,1.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "15.52 51.32 30 65.79 16.94 65.79 2.46 51.32 15.52 51.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "15.55 46.36 2.48 46.36 16.92 31.91 30 31.91 15.55 46.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "73.79 29.89 54.82 48.85 61.36 55.38 80.32 36.41 73.79 29.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.22,
    y: 49.54,
    width: 9.24,
    height: 17.57,
    transform: "translate(-20.49 67.15) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 47.55,
    y: 31.29,
    width: 9.24,
    height: 16.75,
    transform: "translate(-12.76 48.5) rotate(-44.99)"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "165.61 31.91 145.15 31.91 145.15 69.5 134.45 69.5 134.45 31.91 114.11 31.91 114.11 22.68 165.61 22.68 165.61 31.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.03,52.84c7.76-1.81,13.04-6.76,13.04-14.71,0-10.17-8.63-15.46-20.07-15.46h-32.3v46.82h10.63v-15.92h16.93l13.44,15.92h12.78l-14.45-16.65Zm-28.76-8.09v-13.11h21.13c5.62,0,9.77,1.34,9.77,6.56s-4.15,6.56-9.77,6.56h-21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m308.52,22.68v24.75c0,14.05-9.3,23.54-26.29,23.54s-26.28-9.5-26.28-23.54v-24.75h10.7v23.94c0,9.36,5.48,14.98,15.58,14.98s15.58-5.62,15.58-14.98v-23.94h10.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "379.17 60.53 379.17 69.5 330.95 69.5 330.95 22.68 378.51 22.68 378.51 31.64 341.59 31.64 341.59 41.27 372.42 41.27 372.42 50.23 341.59 50.23 341.59 60.53 379.17 60.53"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m105.81,48.84l-18.95-18.94-17.63-17.63C61.08,4.1,50.34,0,39.64,0H6.73L1.58,9.24h38.06c3.6,0,7.2.6,10.64,1.78-8.35.6-16.56,4.1-22.94,10.48l-1.17,1.17H1.59l5.14,9.23h10.2L0,48.84l16.94,16.95H6.73l-5.14,9.23h24.58l1.17,1.17c6.38,6.38,14.59,9.88,22.94,10.48-3.44,1.18-7.03,1.78-10.64,1.78H1.58l5.15,9.24h32.91c10.7,0,21.44-4.1,29.59-12.26l17.63-17.63h0s18.95-18.95,18.95-18.95Zm-13.06,0l-12.43,12.43-12.43-12.42,12.43-12.43h.01s12.41,12.43,12.41,12.43Zm-39.84-28.69c6.86.01,13.66,2.59,18.93,7.79l1.95,1.95-12.43,12.43-11.85-11.85c-3.04-3.05-6.66-5.18-10.49-6.44,4.26-2.57,9.06-3.88,13.88-3.88Zm-22.9,45.63l-16.94-16.95,16.93-16.93h.72c4.46.01,8.87,1.69,12.26,5.1l11.84,11.84-11.84,11.84c-3.39,3.4-7.81,5.08-12.26,5.1h-.71Zm22.9,11.75c-4.82,0-9.62-1.31-13.88-3.88,3.83-1.26,7.44-3.39,10.48-6.44h.01l11.84-11.84,12.42,12.42-1.95,1.95c-5.26,5.2-12.07,7.78-18.93,7.79Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m391.02,27.64c.69-.16,1.16-.6,1.16-1.31,0-.91-.77-1.38-1.79-1.38h-2.7v4.18h.95v-1.42h1.33l1.2,1.42h1.14l-1.29-1.49Zm-2.38-.72v-1.17h1.7c.5,0,.87.12.87.59s-.37.59-.87.59h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m389.81,23.5c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-.82c-2.47,0-4.46,2-4.46,4.46s2,4.46,4.46,4.46,4.46-2,4.46-4.46-2-4.46-4.46-4.46Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueLogoWhiteCopyright);
export default __webpack_public_path__ + "static/media/True-Logo-White-Copyright.6563f18787772668999c2bee290ee851.svg";
export { ForwardRef as ReactComponent };